import type { DynamicPath } from '@unifyapps/defs/types/page';
import _get from 'lodash/get';
import { useMemo } from 'react';

export function useGetPathToOmitFromQueryKey({
  refetchOnPayloadChange = true,
  dataSourceId,
  dynamicPaths,
  inputs,
}: {
  refetchOnPayloadChange?: boolean;
  dataSourceId: string;
  dynamicPaths?: DynamicPath[];
  inputs: Record<string, unknown>;
}) {
  return useMemo(() => {
    const payloadKeysToOmitFromQueryKey: string[] = [];
    if (refetchOnPayloadChange && dynamicPaths) {
      for (let i = 0; i < dynamicPaths.length; i++) {
        const mappedValue = _get({ inputs }, dynamicPaths[i].p);

        if (mappedValue?.includes(dataSourceId)) {
          payloadKeysToOmitFromQueryKey.push(dynamicPaths[i].p);
        }
      }
    }

    return payloadKeysToOmitFromQueryKey;
  }, [refetchOnPayloadChange, dataSourceId, dynamicPaths, inputs]);
}
